import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from 'react/jsx-runtime';
import { TabProvider } from '@ariakit/react';

var Tabs = function Tabs(props) {
  var children = props.children;
  return jsx(TabProvider, _objectSpread(_objectSpread({
    selectOnMove: false
  }, props), {}, {
    children: children
  }));
};

export { Tabs };